module.exports = __webpack_public_path__ + "399a489dad4527258669f691ea7ef70e.svg";